import { importAll, transformImages } from "utils";

import Gallery from "components/Media/Gallery";
import { Link } from "react-router-dom";
import MaraudersMap from "assets/replicas/harry-potter/hp-marauders-map";
import MaraudersMapV7 from "assets/replicas/harry-potter/hp-marauders-map/v7";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import backgroundImage from "./gallery/promo_04.jpg";
import { routes } from "config";

let gallery = [];
let gallery2 = [];
try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/),
  );
  gallery2 = importAll(
    (require as any).context("./gallery-2", false, /\.(png|jpe?g|svg)$/),
  );
} catch (e) {
  console.warn(e);
}

const background = {
  src: backgroundImage,
  opacity: 0.1,
};

const Page = () => {
  const galleryImages = transformImages(gallery);
  const galleryImages2 = transformImages(gallery2);

  return (
    <ReplicaContent>
      <ReplicaParagraph>
        This is a prototype of the{" "}
        <Link
          to={`/${routes.replicaDetailVersion.slug.replace(":id", MaraudersMap.id).replace(":version", `v${MaraudersMapV7.version}`)}#v7-prisoner-of-azkaban`}
          target="_blank"
        >
          Marauder's Map v7 (Prisoner of Azkaban)
        </Link>{" "}
        prop replica. It features all of the elements found in the final
        version, including the 3D staircases, flaps, and page designs. In terms
        of the front-facing presentation and functionality, it is essentially
        identical to the finished replica, with the only notable differences
        being found on the reverse sides of the pages.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages}
        imagesPerRow={4}
        aspectRatio={1}
        imageMaxHeight="200px"
        imageOptions={[{ index: 4, aspectRatio: 2 }]}
      />
      <ReplicaSpacer />

      <ReplicaParagraph>
        As mentioned above, the backsides were never processed or aged. There is
        also a thin unprocessed strip along the right edge of the front page,
        the result of a piece of tape that I had apparently placed there while
        aging the replica for reasons I can no longer remember. The images below
        show all of the affected areas in detail. Despite these imperfections,
        the entire front side is complete and fully finished, making it a
        perfectly suitable display piece.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages2}
        imagesPerRow={5}
        aspectRatio={1}
        imageMaxHeight="200px"
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
      />
      <ReplicaSpacer />
    </ReplicaContent>
  );
};

export default Page;
export { background };
